// extracted by mini-css-extract-plugin
export default {"locations":"locations_locations__pVjwy"};